import { FaCloudDownloadAlt, FaUserShield, FaHeadset, FaUserTie } from "react-icons/fa";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";



export default function ServicesPage() {

  const navigate = useNavigate();

  const services = [
    {
      icon: <FaHeadset size={48} className="text-blue-900" />,
      title: "IT Services",
      description:
        "Ensure your IT infrastructure operates seamlessly with our proactive management and expert support.",
        link: "/It_Outsourse_Tranning_In_Noida",
    },
    {
      icon: <FaUserShield size={48} className="text-blue-900" />,
      title: "Digital Marketing",
      description:
        "Safeguard your business with cutting-edge cybersecurity solutions that defend against evolving threats.",
        link: "/Digital_Marketing_In_Noida",
    },
    {
      icon: <FaUserTie size={48} className="text-blue-900" />,
      title: "Virtual Staffing",
      description:
        "Transform your IT strategy with our tailored consulting services, designed to boost efficiency and growth.",
         link: "/Virtual_Assistant_In_Noida",
    },
    {
      icon: <FaCloudDownloadAlt size={48} className="text-blue-900" />,
      title: "Finance & Accounting",
      description:
        "Streamline your financial operations with our expert accounting services, ensuring accuracy and compliance.",
        link: "/Finanace_Account_In_Noida",
    },
  ];

  return (
    <section className="bg-gray-50 py-20 px-4 md:px-10 lg:px-20">
      <div className="text-center mb-12">
        <h2 className="text-4xl font-bold text-blue-900">Our Services</h2>
        <p className="text-orange-500 mt-2 text-xl font-semibold">
          You Outsource, We Manage & Deliver
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
        {services.map((service, index) => (
          <motion.div
  key={index}
  initial={{ opacity: 0, y: 60 }}
  whileInView={{ opacity: 1, y: 0 }}
  transition={{ duration: 0.6, delay: index * 0.2 }}
  viewport={{ once: true, amount: 0.2 }}
  whileHover={{
    scale: 1.08,
    boxShadow: "0 25px 35px rgba(0, 0, 0, 0.2)",
    transition: { duration: 0.2 },
  }}
  className="bg-white p-8 rounded-xl shadow-md border cursor-pointer"
>

            <div className="flex justify-center mb-6">{service.icon}</div>
            <h3 className="text-orange-500 text-lg font-semibold text-center mb-4">
              {service.title}
            </h3>
            <p className="text-center text-gray-700 mb-6">{service.description}</p>
            <div className="flex justify-center">
              <button
  onClick={() => navigate(service.link)}
  className="bg-blue-900 text-white px-6 py-2 rounded-full font-semibold hover:bg-orange-600 transition"
>
  Read More About
</button>
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
